import { render, staticRenderFns } from "./meansDetails.vue?vue&type=template&id=08780d02&scoped=true&"
import script from "./meansDetails.vue?vue&type=script&lang=js&"
export * from "./meansDetails.vue?vue&type=script&lang=js&"
import style0 from "./meansDetails.vue?vue&type=style&index=0&id=08780d02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08780d02",
  null
  
)

export default component.exports